import { ArrowDownIcon, CalendarIcon } from '@src/shared/ui/icons';
import { DateInput, InputAdornment } from '@src/shared/ui/inputs';

import { type ComponentRef, forwardRef, useState } from 'react';
import CalendarHeader from './CalendarHeader';
import StyleSheet from './styles';

interface DayPickerProps {
  value?: Date;
  onChange?: (date: Date | null) => void;
}
type DateFieldRef = ComponentRef<typeof DateInput>;
const DayPicker = forwardRef<DateFieldRef, DayPickerProps>((props, ref) => {
  const [open, setOpen] = useState(false);

  const { onChange, ...rest } = props;
  const handleChange = (newValue: Date | null) => {
    onChange?.(newValue);
  };
  return (
    <DateInput
      ref={ref}
      {...rest}
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      onChange={handleChange}
      views={['day']}
      format="MMMM dd, yyyy"
      slots={{
        openPickerIcon: ArrowDownIcon,
        calendarHeader: CalendarHeader,
      }}
      slotProps={{
        textField: {
          readOnly: true,
          onClick: () => setOpen(true),
          InputProps: {
            readOnly: true,
            startAdornment: (
              <InputAdornment position="start">
                <CalendarIcon />
              </InputAdornment>
            ),
            sx: { cursor: 'pointer', '& input': { cursor: 'pointer' } },
          },
        },
      }}
      sx={StyleSheet.monthPicker}
    />
  );
});
export default DayPicker;
